import { render, staticRenderFns } from "./ProductLedger.vue?vue&type=template&id=10dc71fa&scoped=true"
import script from "./ProductLedger.vue?vue&type=script&lang=js"
export * from "./ProductLedger.vue?vue&type=script&lang=js"
import style0 from "./ProductLedger.vue?vue&type=style&index=0&id=10dc71fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc71fa",
  null
  
)

export default component.exports